const protocol=window.location.protocol==='http:'?'http:':'https:';

const apiRoots = {
  PROD_HOST: 'zyyd.dia-solution.com',
  PRE_HOST: 'zyyd.pre.dia-solution.com',
  QA_HOST: 'zyyd.qa.dia-solution.com',
  getMallWechatApi() {
    var host = window.location.host;
    if (host.indexOf(this.PROD_HOST) > -1) {
      return protocol + '//api.dia-solution.com/mall-wechat/v3';
    } else if (host.indexOf(this.PRE_HOST) > -1) {
      // return 'http://api.pre.dia-solution.com/mall-wechat/v3';
      return protocol + `//zyyd.pre.dia-solution.com/api/v3`; //运维配的
    } else {
      return protocol + '//api.qa.dia-solution.com/mall-wechat/v3';
    }
  },

  getPayDomain() {
    var host = window.location.host;
    if (host.indexOf(this.PROD_HOST) > -1) {
      return protocol + '//static.dia-solution.com/';
    } else if (host.indexOf(this.PRE_HOST) > -1) {
      return protocol + '//static.pre.dia-solution.com/';
    } else {
      return protocol + '//static.qa.dia-solution.com/';
    }
  },

  // getMallApi() {
  //   var host = window.location.host;
  //   if (host.indexOf(this.PROD_HOST) > -1) {
  //     return protocol + '//mall.91jkys.com/api/v3';
  //   } else if (host.indexOf(this.PRE_HOST) > -1) {
  //     return protocol + '//mall.pre.91jkys.com/api/v3';
  //   } else {
  //     return 'http://api.qa.91jkys.com/mall/v3';
  //   }
  // },

  getZyydApi() {
    var host = window.location.host;
    if (host.indexOf(this.PROD_HOST) > -1) {
      return protocol + '//api-zyyd.dia-solution.com';
    } else if (host.indexOf(this.PRE_HOST) > -1) {
      return protocol + '//api-zyyd.pre.dia-solution.com';
    } else {
      return protocol + '//api.zyyd.qa.dia-solution.com';
    }
  },

  getGwApi() {
    var host = window.location.host;
    if (host.indexOf(this.PROD_HOST) > -1) {
      return protocol + '//apigw-volc.dia-solution.com/api';
    } else if (host.indexOf(this.PRE_HOST) > -1) {
      return protocol + '//apigw.pre.dia-solution.com/api';
    } else {
      // return 'http://newc-qa.apigw.qa.dia-solution.com/api';
      return protocol + '//apigw.qa.dia-solution.com/api';
    }
  },

  getCommonApi() {
    var args = Array.prototype.slice.call(arguments);
    var host = window.location.host;
    var port = '',
      rootUrl = '/',
      apiUrl = 'api';
    if (args.length == 1) {
      // 只传递port
      port = args[0];
    } else if (args.length == 2) {
      // 只传递port和rootUrl
      port = args[0];
      rootUrl = args[1];
    } else if (args.length == 3) {
      // 按顺序传递port、rootUrl、apiUrl
      port = args[0];
      rootUrl = args[1];
      apiUrl = args[2];
    }
    var getPortWithProtocol = protocol == 'http:' ? port : port - 1000;
    if (host.indexOf(this.PROD_HOST) > -1) {
      return protocol + '//' + apiUrl + '.91jkys.com' + (port ? ':' + getPortWithProtocol : '') + rootUrl;
    } else if (host.indexOf(this.PRE_HOST) > -1) {
      return protocol + '//' + apiUrl + '.pre.91jkys.com' + (port ? ':' + getPortWithProtocol : '') + rootUrl;
    } else {
      return protocol + '//' + apiUrl + '.qa.91jkys.com' + (port ? ':' + port : '') + rootUrl;
    }
  }
};

export default apiRoots;
